export let mapInstance = null;
export let draw = null;
export let isDrawingMode = false;
export let trimPopup = null;
export let isMouseOverPhoto = false;
export let isMouseOverNote = false;
export let apiCounter = 0;

export let visibleTrackIds = new Set();
export let trackDataCache = {};
export let notesByTrackId = {};
export let boatDataCache = {};
export let activeTrip = null;
export let currentUser = null;
export let colorIndex = 0;

export function setMapInstance(instance) {
  mapInstance = instance;
}

export function setDraw(d) {
  draw = d;
}

export function setCurrentUser(user) {
    currentUser = user;
}

export function setIsMouseOverPhoto(isOver) {
    isMouseOverPhoto = isOver;
}

export function setIsMouseOverNote(isOver) {
    isMouseOverNote = isOver;
}

export function setTrimPopup(p) {
    trimPopup = p;
}

export function setDrawingMode(isDrawing) {
    isDrawingMode = isDrawing;
}

export function incrementApiCounter() {
    apiCounter++;
}

export function decrementApiCounter() {
    apiCounter--;
}

export function resetColorIndex() {
    colorIndex = 0;
}

export function incrementColorIndex() {
    colorIndex++;
}

export function setActiveTrip(trip) {
    activeTrip = trip;
}

export let photosVisible = true;
export let notesVisible = true;

export function setPhotosVisible(v) { photosVisible = v; }
export function setNotesVisible(v) { notesVisible = v; }

export function clearTrackState() {
    visibleTrackIds.clear();
    trackDataCache = {};
    notesByTrackId = {};
    resetColorIndex();
}
